import { KPICard } from '../ui/KPICard';
import { formatBR } from '../../lib/utils';
import type { DashboardSummary } from '../../lib/types';

export interface KPIStripProps {
  data?: DashboardSummary;
  accent: string;
  loading?: boolean;
}

function Skel() {
  return (
    <div
      className="animate-pulse bg-surfaceAlt"
      style={{ height: 86 }}
      aria-hidden="true"
    />
  );
}

export function KPIStrip({ data, accent, loading }: KPIStripProps) {
  if (loading || !data) {
    return (
      <div
        className="grid grid-cols-2 sm:grid-cols-4 gap-px bg-border border border-border rounded-lg overflow-hidden mb-3"
        data-testid="kpi-strip-skeleton"
      >
        {Array.from({ length: 4 }).map((_, i) => (
          <Skel key={i} />
        ))}
      </div>
    );
  }
  const t = data.totals;
  const pct =
    t.totalMachines > 0 ? (t.currentMachines / t.totalMachines) * 100 : 0;
  return (
    <div
      className="grid grid-cols-2 sm:grid-cols-4 gap-px bg-border border border-border rounded-lg overflow-hidden mb-3"
      data-testid="kpi-strip"
    >
      <KPICard
        label="Máquinas"
        value={formatBR(t.currentMachines)}
        sub={`/${formatBR(t.totalMachines)}`}
        trend={`${pct.toFixed(0)}%`}
        color={accent}
      />
      <KPICard
        label="Serviços"
        value={formatBR(t.services)}
        sub="ativos"
        color="#0a0a0b"
      />
      <KPICard
        label="Nodes"
        value={`${formatBR(t.nodesOk)}/${formatBR(t.nodesOk + t.nodesDown)}`}
        sub="online"
        color="#15803d"
      />
      <KPICard
        label="Escala"
        value={formatBR(data.breakdowns?.byStack.length ?? 0)}
        sub={`filas · ${formatBR(data.breakdowns?.bySystem.length ?? 0)} sist.`}
        color="#0a0a0b"
      />
    </div>
  );
}

export default KPIStrip;
